import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 业主评价排行 统计，统计详情服务
 */
export class EvaluteResultController {
    constructor() {
        this.baseurl = 'EvaluteResultController.assx/';
    }

    /**
     * 获取评价项中选择三星以下其他的具体描述其他
     * token:String, cantonCode:String, streetOfficeOrgCode:String, residentsCommitteeOrgCode:String, eaAresCode:String, year:int, month:int, evaluateObjType:int, discontentKey:String, startIndex:int, maxSize:int
     */
    GetAreaDiscontentItemOfIsElseList(token, cantonCode, streetOfficeOrgCode, residentsCommitteeOrgCode, eaAresCode, year, month, evaluateObjType, discontentKey, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetAreaDiscontentItemOfIsElseList', Qs.stringify({ token: token, cantonCode: cantonCode, streetOfficeOrgCode: streetOfficeOrgCode, residentsCommitteeOrgCode: residentsCommitteeOrgCode, eaAresCode: eaAresCode, year: year, month: month, evaluateObjType: evaluateObjType, discontentKey: discontentKey, startIndex: startIndex, maxSize: maxSize }));
    }

    /**
     * 获取评价中的其他内容
     * token:String, cantonCode:String, orgCode:String, streetOfficeOrgCode:String, residentsCommitteeOrgCode:String, eaAresCode:String, year:int, month:int, evaluateObjType:int, startIndex:int, maxSize:int
     */
    getAreaEvaluteRecordElseList(token, cantonCode, orgCode, streetOfficeOrgCode, residentsCommitteeOrgCode, eaAresCode, year, month, evaluateObjType, startIndex, maxSize) {
        return request.post(this.baseurl + 'getAreaEvaluteRecordElseList', Qs.stringify({ token: token, cantonCode: cantonCode, orgCode: orgCode, streetOfficeOrgCode: streetOfficeOrgCode, residentsCommitteeOrgCode: residentsCommitteeOrgCode, eaAresCode: eaAresCode, year: year, month: month, evaluateObjType: evaluateObjType, startIndex: startIndex, maxSize: maxSize }));
    }

    /**
     * 获取近六个月口碑评价倒数10名的物业区域列表
     * token:String
     */
    GetEaAreaBlacklist(token) {
        return request.post(this.baseurl + 'GetEaAreaBlacklist', Qs.stringify({ token: token }));
    }

    /**
     * 获取近六个月口碑评价倒数10名的企业列表
     * token:String, evaluateObjType:int
     */
    GetBlacklist(token, evaluateObjType) {
        return request.post(this.baseurl + 'GetBlacklist', Qs.stringify({ token: token, evaluateObjType: evaluateObjType }));
    }

    /**
     * 获取排行统计列表
     * year:int, month:int, evaluateObjType:int, cantonCode:String, streetOfficeOrgCode:String, residentsCommitteeOrgCode:String, orgCode:String, startIndex:int, size:int,
     *   type:boolean   true -正序  false-倒叙
     */
    GetRankInfoList(year, month, evaluateObjType, cantonCode, streetOfficeOrgCode, residentsCommitteeOrgCode, orgCode, startIndex, size,type) {
        return request.post(this.baseurl + 'GetRankInfoList', Qs.stringify({ year: year, month: month, evaluateObjType: evaluateObjType, 
            cantonCode: cantonCode, streetOfficeOrgCode: streetOfficeOrgCode, residentsCommitteeOrgCode: residentsCommitteeOrgCode, orgCode: orgCode, 
            startIndex: startIndex, size: size,type:type }));
    }

    /**
     * 近6月得分走势
     * year:int, month:int
     */
    GetScoreTrend(year, month) {
        return request.post(this.baseurl + 'GetScoreTrend', Qs.stringify({ year: year, month: month }));
    }

    /**
     * 获取上月排名前十或后十的物业区域
     * year:int, month:int, type:boolean, rankType:int, code:String
     */
    GetTopTenEaAreaList(year, month, type, rankType, code) {
        return request.post(this.baseurl + 'GetTopTenEaAreaList', Qs.stringify({ year: year, month: month, type: type, rankType: rankType, code: code }));
    }

    /**
     * 获取业主评价小区单日统计结果
     * token:String, param:String
     */
    GetEvaluatePush(token, param) {
        return request.post(this.baseurl + 'GetEvaluatePush', Qs.stringify({ token: token, param: param }));
    }

    /**
     * 获取上月排名前十或后十的机构
     * year:int, month:int, evaluateObjType:int, type:boolean, rankType:int, code:String
     */
    GetTopTenOrgList(year, month, evaluateObjType, type, rankType, code) {
        return request.post(this.baseurl + 'GetTopTenOrgList', Qs.stringify({ year: year, month: month, evaluateObjType: evaluateObjType, type: type, rankType: rankType, code: code }));
    }

    /**
     * 获取评价记录列表
     * code:String, codeType:int, year:int, month:int, evaluateObjType:int, scored:boolean, startIndex:int, maxSize:int
     */
    GetEvaluateRecordList(code, codeType, year, month, evaluateObjType, scored, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetEvaluateRecordList', Qs.stringify({ code: code, codeType: codeType, year: year, month: month, evaluateObjType: evaluateObjType, scored: scored, startIndex: startIndex, maxSize: maxSize }));
    }

    /**
     * 根据机构代码获取所管项目评价情况
     * eaAreaCode:String, orgCode:String, year:int, month:int, evaluateObjType:int, startIndex:int, maxSize:int
     */
    GetEvaluateScoreResultListByOrgCode(eaAreaCode, orgCode, year, month, evaluateObjType, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetEvaluateScoreResultListByOrgCode', Qs.stringify({ eaAreaCode: eaAreaCode, orgCode: orgCode, year: year, month: month, evaluateObjType: evaluateObjType, startIndex: startIndex, maxSize: maxSize }));
    }

    /**
     * 获取业主评价详细统计
     * token:String, cantonCode:String, streetOfficeOrgCode:String, residentsCommitteeOrgCode:String, eaAresCode:String, year:int, month:int, evaluateObjType:int
     */
    GetEvaAreaStatistics(token, cantonCode, streetOfficeOrgCode, residentsCommitteeOrgCode, eaAresCode, year, month, evaluateObjType) {
        return request.post(this.baseurl + 'GetEvaAreaStatistics', Qs.stringify({ token: token, cantonCode: cantonCode, streetOfficeOrgCode: streetOfficeOrgCode, residentsCommitteeOrgCode: residentsCommitteeOrgCode, eaAresCode: eaAresCode, year: year, month: month, evaluateObjType: evaluateObjType }));
    }

    /**
     * 获取每日推送业主评价记录信息
     * token:String, eaAreaCode:String, starType:String, dateType:int, date:Date, order:HashMap, startIndex:int, maxSize:int
     */
    GetEvaluateRecordListOfEvaluatePush(token, eaAreaCode, starType, dateType, date, order, startIndex, maxSize) {
        return request.post(this.baseurl + 'GetEvaluateRecordListOfEvaluatePush', Qs.stringify({ token: token, eaAreaCode: eaAreaCode, starType: starType, dateType: dateType, date: date, order: (typeof order === 'undefined' || order === null) ? '' : order.toString(), startIndex: startIndex, maxSize: maxSize }));
    }
}